import { Dialog, type DialogProps } from 'primereact/dialog';
import { TabPanel, TabView } from 'primereact/tabview';
import { classNames } from 'primereact/utils';
import { MdArrowBack } from 'react-icons/md';
import style from '../../../views/employee.module.css';
import Messages from './Messages';
import OrderDetails from './OrderDetails';
import Timeline from './Timeline';
import { TabHelper } from '@/common/TabHelper';
import type { X4bActivityDto } from '@/modules/vehicle/engine/X4bActivityDto';

type Transaction = {
	id: string;
	pickup: string;
	pickupAddress: string;
	dropoff: string;
	dropoffAddress: string;
	fare: number;
	status: string;
	duration: string;
	distance: string;
	paymentMethod: string;
	bookingMethod: string;
	driverName: string;
	driverRating: number;
	carDetails: string;
	carPlate: string;
};

type Message = {
	id: number;
	text: string;
	sender: string;
	timestamp: Date;
	isUser: boolean;
};

interface Props extends DialogProps {
	transaction: Transaction;
	activity?: X4bActivityDto | null;
}

const TransactionDetails = (props: Props) => {
	const { transaction, activity, onHide } = props;

	const headerTemplate = (
		<div className="flex items-center gap-2.5">
			<MdArrowBack
				size={24}
				className="text-primary m-2"
				onClick={onHide}
			/>
			<h1 className="text-headline-small text-[28px] font-semibold">
				TX ID: {transaction.id}
			</h1>
		</div>
	);

	const messages: Message[] = [
		{
			id: 1,
			text: "I'm on my way po",
			sender: 'A',
			timestamp: new Date('2023-05-27T08:27:00'),
			isUser: false,
		},
		{
			id: 2,
			text: 'Ok po kuya',
			sender: 'A',
			timestamp: new Date('2023-05-27T08:30:00'),
			isUser: true,
		},
	];

	return (
		<Dialog
			{...props}
			draggable={false}
			header={headerTemplate}
			pt={{
				root: () => ({
					className: classNames(
						style.employeeModalTop,
						style.employeeModalBottom,
						style.employeeModalRoot,
					),
				}),
				header: {
					className: classNames(
						style.employeeModalHeader,
						style.employeeModalTop,
					),
				},
				content: {
					className: classNames(
						style.employeeModalBottom,
						'border-t px-8',
					),
				},
			}}
		>
			<TabView
				pt={TabHelper.TabViewProps}
			>
				<TabPanel
					pt={TabHelper.TabPanelProps}
					header="Order Details"
				>
					<OrderDetails transaction={transaction} activity={activity} />
				</TabPanel>
				<TabPanel
					pt={TabHelper.TabPanelProps}
					header="Messages"
				>
					<Messages messages={messages} />
				</TabPanel>

				<TabPanel
					pt={TabHelper.TabPanelProps}
					header="Timeline"
				>
					<Timeline activity={activity} />
				</TabPanel>
			</TabView>
		</Dialog>
	);
};

export default TransactionDetails;
